import { MOBILE_WIDTH } from "./config";

function getRandomNumber(min: number, max: number): number {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function generatePlumeIcon(ww: number, smokeDiv: HTMLDivElement): void {
  // @ts-ignore
  smokeDiv.innerText = "";

  const isMobile = ww <= MOBILE_WIDTH;
  const maxHeight = isMobile ? 25 : 30;

  for (let i = 0; i < 25; i++) {
    const plume = document.createElement("div");
    plume?.classList.add(`smoke-plume`);
    plume.style.height = `${getRandomNumber(10, maxHeight)}px`;
    plume.style.transform = `rotate(${getRandomNumber(0, 360)}deg)`;
    smokeDiv?.appendChild(plume);
  }
}
